var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0954 15.1101C69.0954 14.2093 68.5513 13.3977 67.7182 13.0554L36.3441 0.166597C35.8032 -0.0555323 35.1968 -0.0555323 34.6559 0.166597L3.28183 13.0554C2.44871 13.3976 1.90463 14.2093 1.90463 15.1101V55.8899C1.90463 56.7907 2.44857 57.6023 3.28183 57.9446L34.6559 70.8334C35.191 71.0532 35.7924 71.0579 36.3413 70.8333C36.3681 70.8244 35.1803 71.3115 67.7182 57.9446C68.5515 57.6024 69.0954 56.7907 69.0954 55.8899V15.1101ZM35.5 25.7842L23.9399 21.0352L48.9226 10.1369L61.2559 15.2035L35.5 25.7842ZM6.34722 18.6108L16.321 22.7081V34.2677C16.321 35.4944 17.3155 36.489 18.5423 36.489C19.769 36.489 20.7635 35.4944 20.7635 34.2677V24.5332L33.2787 29.6745V65.4647L6.34722 54.401V18.6108ZM35.5 4.62265L43.2004 7.78605L18.2177 18.6844L9.74413 15.2034L35.5 4.62265ZM37.7213 29.6745L64.6528 18.6108V54.401L37.7213 65.4647V29.6745Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDelivery);
export default __webpack_public_path__ + "static/media/free-delivery.a37c4eef89b95f1b39ca28b44c7ef666.svg";
export { ForwardRef as ReactComponent };